import { Layer } from 'leaflet'
import { useCallback } from 'react'
import { GeoJSON } from 'react-leaflet'

import { Map } from '@/components/map'
import { InterestLayers } from '@/constants/diagnoses'
import { UseGetPhysiologicalDiagnosesMapResponse } from '@/hooks/queries/use-get-physiological-diagnoses-map'

import InfoButton from './info-button'
import { useStyles } from './styles'

type GeoJsonProps = {
  data: NonNullable<UseGetPhysiologicalDiagnosesMapResponse>
  geoJsonBounds?: L.LatLngBounds
  disabledControls?: boolean
  measurement: string
  title: string
  message: string
  selectedLayer: InterestLayers
}

export const GeoJsonMap = ({
  data,
  geoJsonBounds,
  disabledControls,
  measurement,
  title,
  message,
  selectedLayer,
}: GeoJsonProps) => {
  const classes = useStyles()

  const onEachFeature = useCallback(
    (props: { name: string; value?: number }, layer: Layer) => {
      const { name, value } = props
      const formattedValue = value
        ? `${Number(value.toFixed(2))}${measurement}`
        : ''

      const tooltipMessage = `
        <div>
          ${name}:
          ${formattedValue}
        </div>
      `

      layer.bindTooltip(tooltipMessage, {
        className: classes.tooltip,
        opacity: 1,
        offset: [0, -5],
        interactive: true,
        direction: 'top',
      })
    },
    [],
  )

  return (
    <Map bounds={geoJsonBounds} disabledControls={disabledControls}>
      {!disabledControls && <InfoButton title={title} message={message} />}
      <GeoJSON
        data={data.layers}
        style={(feature) => ({
          color: feature?.properties[selectedLayer].color,
          fillOpacity: 1,
          fillRule: 'nonzero',
        })}
        onEachFeature={(feature, layer) =>
          onEachFeature(
            {
              name: feature.properties.field,
              value: feature?.properties[selectedLayer].value,
            },
            layer,
          )
        }
      />
      <GeoJSON
        data={data.fields}
        style={(feature) => ({
          color: feature?.properties.color,
          fillOpacity: 0,
          weight: 5,
          fillRule: 'nonzero',
        })}
      />
    </Map>
  )
}
